let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("btvHm")).then(() => parcelRequire('hgsJA'));